
export enum ERegion {
    Est = "Est",
    Ouest =  "Ouest", 
    Nord = "Nord", 
    Sud = "Sud"
}